<template>
  <dr-wrapper v-bind="$props" v-on="wrapOn" v-if="isInEditorMode">
    <div>
      <span v-if="!isHideLabel" :style="{fontSize: fontSizeFromModel + 'px'}" class="raiting-widget-value">{{ ratingValue }}</span>
      <v-rating v-model="ratingValue" background-color="gray lighten-3" half-increments color="yellow" hover length="5" :size="size"></v-rating>
    </div>
  </dr-wrapper>
  <div v-else-if="isVisible" :class="[evaluateClasses({ classes: model.Class })]">
    <span v-if="!isHideLabel" :style="{fontSize: fontSizeFromModel + 'px'}" class="raiting-widget-value">{{ ratingValue }}</span>
    <v-rating :readonly="isReadonly" v-model="ratingValue" background-color="gray lighten-3" half-increments color="yellow" hover length="5" :size="size"></v-rating>
  </div>
</template>

<script>
import inputMixin from '../../mixins/input-mixin'
import baseMixin from '../../mixins/base-mixin'
import inputWidgetsWrapperMixin from '../../mixins/input-widgets-wrapper-mixin'
import actionMixin from '../../mixins/actions-mixin'

export default {
  props: ['model'],
  mixins: [inputMixin, baseMixin, actionMixin, inputWidgetsWrapperMixin],
  computed: {
    ratingValue: {
      get() {
        const value = parseFloat(this.getDataSourceField(this.model.Value))
        if (isNaN(value)) {
          return 0
        }
        return value
      },
      set(value) {
        this.invokeActionOnClick(this.model.ActionOnclick, { RatingValue: value })
      }
    },
    isHideLabel() {
      return this.model.HideLabel
    },
    fontSizeFromModel() {
      if (this.model.Size === 35) {
        return 14
      }

      if (this.model.Size === 50) {
        return 17
      }

      return 25
    },
    size() {
      return this.model.Size
    }
  }
}
</script>

<style lang="scss" scoped>
.raiting-widget-value {
  font-weight: 500;
  color: #bababa
}
</style>